import { Component, inject, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

// Translator.
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

// Services.
import { SIESPServicesService } from '../../services/siespServices.service';
import { ReportsService } from '../../services/reports.service';

// Material.
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule }  from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-image-viewer',
    standalone: true,
    imports: [
      MatDialogModule,
      MatButtonModule,
      TranslatePipe,
      MatIconModule,
      CommonModule,
      NgxSpinnerModule,
      MatDividerModule
    ],
    templateUrl: './image-viewer.component.html',
    styleUrl: './image-viewer.component.scss'
})
export class ImageViewerComponent implements OnInit {
    constructor(
      private dialogRef: MatDialogRef<ImageViewerComponent>,
      public translate: TranslateService,
      private spinner: NgxSpinnerService,
      private api: SIESPServicesService,
      private rapi: ReportsService,
      @Inject(MAT_DIALOG_DATA) public data: any
    ){}
    private _snackBar = inject(MatSnackBar);
    image: any = null;

    ngOnInit(): void {
        
    }

    closeModal() {
        this.dialogRef.close();
    }

    openSnackBar(Message: string) {
      this._snackBar.open(Message, "Dismiss", { duration: 5000 });
    }
}